import React from "react";
import "./ShimmerDetail.css";
const ShimmerDetail = () => {
  return (
    <div className="container card__container">
      <div className="card__detail"></div>
      <div className="content">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default ShimmerDetail;
